import { render, staticRenderFns } from "./PermissionsView.vue?vue&type=template&id=43f82bdb&scoped=true&lang=pug&"
import script from "./PermissionsView.vue?vue&type=script&lang=ts&"
export * from "./PermissionsView.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionsView.vue?vue&type=style&index=0&id=43f82bdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f82bdb",
  null
  
)

export default component.exports